function emptyToNull(value) {
  const text = String(value ?? '').trim();
  return text || null;
}

function upperCode(value) {
  return String(value ?? '').trim().toUpperCase();
}

function buildOptions(item) {
  return (item.options ?? [])
    .map((option) => ({
      value: String(option?.value ?? '').trim(),
      label: String(option?.label ?? '').trim(),
    }))
    .filter((option) => option.value || option.label);
}

function buildCriteria(item) {
  const dataType = item.dataType;
  if (dataType === 'DECIMAL') {
    const scale = Number(item.scale);
    if (item.operator === 'BETWEEN') {
      return {
        operator: 'BETWEEN',
        scale,
        min: String(item.min ?? '').trim(),
        max: String(item.max ?? '').trim(),
        minInclusive: Boolean(item.minInclusive),
        maxInclusive: Boolean(item.maxInclusive),
      };
    }
    return {
      operator: item.operator,
      scale,
      expectedValue: String(item.expectedValue ?? '').trim(),
    };
  }

  if (dataType === 'BOOLEAN') {
    return {
      operator: 'EQUALS',
      expectedValue: item.expectedValue === true || item.expectedValue === 'true',
    };
  }

  if (dataType === 'SINGLE_SELECT') {
    const options = buildOptions(item);
    const allowed = new Set(options.map((option) => option.value));
    return {
      operator: 'IN',
      options,
      passingValues: (item.passingValues ?? []).filter((value) => allowed.has(value)),
    };
  }

  if (dataType === 'TEXT' && item.operator === 'EXACT_EQUALS') {
    return {
      operator: 'EXACT_EQUALS',
      expectedValue: String(item.expectedValue ?? ''),
    };
  }

  if (dataType === 'TEXT') {
    return { operator: item.operator };
  }

  return { operator: 'DIRECT' };
}

function buildItem(item, index) {
  const dataType = item.dataType;
  return {
    itemCode: upperCode(item.itemCode),
    itemName: String(item.itemName ?? '').trim(),
    dataType,
    unit: dataType === 'DECIMAL' ? emptyToNull(item.unit) : null,
    sequence: index + 1,
    required: Boolean(item.required),
    criteria: buildCriteria(item),
    remark: emptyToNull(item.remark),
  };
}

/**
 * @param {object} values 表單值（camelCase）
 * @param {{ updatedAt?: string|null, includeUpdatedAt?: boolean }} [options]
 */
export function buildInspectionKindWritePayload(values, options = {}) {
  const payload = {
    code: upperCode(values.code),
    name: String(values.name ?? '').trim(),
    status: values.status,
    items: (values.items ?? []).map(buildItem),
  };

  if (options.includeUpdatedAt) {
    payload.updatedAt = options.updatedAt ?? null;
  }

  return payload;
}
